// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2KBcH","emails":"CreateEditClinics_emails__2-bpK","emailTagLabel":"CreateEditClinics_emailTagLabel__3KcHd"};